import * as types from '../constants/authConstants';

const initialState = {
  userData: null,
  accessToken: null,
  loginError: null,
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.LOGOUT:
      return {
        ...initialState,
      };

    case types.AUTHORIZATION_SUCCESS:
      return {
        ...state,
        userData: payload ? payload.user : null,
        accessToken: payload ? payload.accessToken : null,
        loginError: null,
      };

    case types.AUTHORIZATION_FAIL:
      return {
        ...state,
        loginError: payload,
      };

    default:
      return state;
  }
};

export default authReducer;
